import { Product, ProductFilter } from '../../types/Product';
import { Category, CLPFilter } from 'types/Category';
import { caseInsensitiveSlugMatch } from 'helpers/strings';

const scrubFilterFromName = (input = ''): string => input.replace('filter_', '');

export const productMatchesFilters = (product: Product, filterState: CLPFilter[]): boolean => {
  // Filter out any irrelevant product filter options so we don't loop through superfluous data
  const relevantProductFilters = product.filters.filter(
    (filter: ProductFilter) => !!filterState.find(csf => scrubFilterFromName(csf.attributeCode) === filter.name)
  );

  return filterState.every((clpSelectedFilter: CLPFilter) => {
    const matchingProductFilter = relevantProductFilters.find(
      (filter: ProductFilter) => filter.name === scrubFilterFromName(clpSelectedFilter.attributeCode)
    );

    // Option and value mean the same thing in this context
    return clpSelectedFilter.options.some((filterOption: string) => {
      return matchingProductFilter?.values.some((productFilterValue: string) => caseInsensitiveSlugMatch(filterOption, productFilterValue));
    });
  });
};

export const useFilters = (category: Category, clpSelectedFilters: CLPFilter[]): Category => {
  if (!category.availableFilters || Object.keys(category.availableFilters).length === 0) {
    return category;
  }

  let filteredProducts = category.products;
  if (clpSelectedFilters.length !== 0) {
    filteredProducts = filteredProducts.filter(
      (product: Product) => productMatchesFilters(product, clpSelectedFilters)
    );
  }

  return {
    ...category,
    products: filteredProducts
  };
};
